/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the matching to consider:
 *   * EXACT_MATCH : a case sensitive exact matching
 *   * EXACT_MATCH_IGNORE_CASE : a case insensitive exact match
 *   * PARTIAL_MATCH : a case sensitive partial matching
 *   * PARTIAL_MATCH_IGNORE_CASE : a case insensitive partial matching
 */
export enum MatchingType {
  EXACT_MATCH = 'EXACT_MATCH',
  EXACT_MATCH_IGNORE_CASE = 'EXACT_MATCH_IGNORE_CASE',
  PARTIAL_MATCH = 'PARTIAL_MATCH',
  PARTIAL_MATCH_IGNORE_CASE = 'PARTIAL_MATCH_IGNORE_CASE'
}
